import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  loadList: [],
  loadCount: 0,
  driverList: [],
  vehicleList: [],
  loadDetailList: [],
  tabKey: "created",
};
export default function tripDesignReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_LOAD_SUCCESS_ACTION:
      return {
        ...state,
        loadList: action.payload.rows,
        loadCount: action.payload.count,
        processing: false,
      };
    case actionTypes.FETCH_LOAD_ID_SUCCESS_ACTION:
      return {
        ...state,
        loadDetailList: action.payload,
      };
    case actionTypes.TAB_KEY_INIT_ACTION:
      return {
        ...state,
        tabKey: action.value,
      };

    case actionTypes.FETCH_LOAD_INIT_ACTION:
      return {
        ...state,
        processing: true,
      };
    case actionTypes.FETCH_SUBLOG_SUCCESS_ACTION:
      return {
        ...state,
        subLog: action.payload.rows,
      };

      case actionTypes.GET_PAYMODE_SUCCESS:
      return {
        ...state,
        payMode: action.payload.rows.filter(
          (i) => i.name !== "subscription" && i.name !== "bid"
        ),
        actualPayMode: action.payload.rows,
        bidPayMode: action.payload.rows.filter((i) => i.name === "bid"),
        subscriptionPayMode: action.payload.rows.filter(
          (i) => i.name === "subscription"
        ),
        bankPayMode: action.payload.rows.filter(
          (i) => i.name === "bank transfer"
        ),
        codPayMode: action.payload.rows.filter(
          (i) => i.name === "cash on delivery"
        ),
      };

    default:
      return {
        ...state,
      };
  }
}
